<template>
    <div class="form">
        <div v-if="!artist" class="lds-dual-ring"></div>
        <form v-else>
            <BasicPersonalInfo
                ref="basicPersonalForm"
                @change-state="updateState"
                @update-avatar="updateAvatar"
            />

            <ArtistWorkInfo :agreement="artist.file_agreement" ref="artistWorkForm" @change-state="updateState" />

            <LocationInfo ref="locationForm" @change-state="updateState" />

            <PerformanceDetails ref="performanceForm"  @change-state="updateState" />

            <FileContainer
                :file-info="artist.file_technical_requirements"
                :user-id="artist.id"
                :field="`technical_requirements`"
                @upload-file="uploadFile"
            >
                <template v-slot:header>
                    <p class="form-question mb-0">What are your TECHNICAL REQUIREMENTS for your show if you have
                        any?</p>
                    <p class="color_primary">if complex, you may attach a rider for these requirements below</p>
                </template>
            </FileContainer>

            <FileContainer
                :file-info="artist.file_rider"
                :user-id="artist.id"
                :field="`rider`"
                @upload-file="uploadFile"
            >
                <template v-slot:header>
                    <p class="form-question">Rider</p>
                </template>
            </FileContainer>

            <BaseButtons
                v-if="isPermission"
                :on-save="validate"
                :on-cancel="reloadPage"
            />

        </form>
    </div>
</template>

<script>
import BasicPersonalInfo from "./BasicPersonalInfo.vue";
import ArtistWorkInfo from "./ArtistWorkInfo.vue";
import LocationInfo from "./LocationInfo.vue";
import PerformanceDetails from "./PerformanceDetails.vue";
import FileContainer from "../Common/FileContainer.vue";
import BaseButtons from "../Common/BaseButtons.vue";
import {mapActions, mapState} from "pinia";
import {useArtistStore} from "../../stores/ArtistStore";
import ArtistService from "../../services/ArtistService";
import ModalHandler from "../../mixins/ModalHandler";

export default {

    name: 'ArtistInformationTab',
    components: {BaseButtons, FileContainer, PerformanceDetails, LocationInfo, ArtistWorkInfo, BasicPersonalInfo},
    mixins: [ ModalHandler ],
    data() {
        return {
            information: {},
        }
    },

    props: {
        adminType: String
    },


    computed: {
        ...mapState(useArtistStore, {
            artist: 'artist',
            artistId: 'artistId'
        }),
        isPermission() {
            return this.adminType !== 'agent'
        },
    },

    watch: {
        'artist.file_avatar'(val) {
            if (val) {
                this.information.avatar = this.artist.file_avatar.id;
            }
        }
    },

    methods: {
        async updateArtistInfo() {
            try {
                await ArtistService.updateGeneralArtistInfo(this.artistId, this.information);
                this.$showSuccessMessage('Profile was successfully updated')
            } catch (error) {
                this.$showErrorMessage('The profile has not been updated')
            }
        },
        updateState({ state }) {
            this.information = {...this.information,  ...state};
        },
        updateAvatar(avatar) {
            this.information.avatar = avatar;
        },
        uploadFile(file, type) {
            if (!file) {
                this.information[type] = null
            } else {
                this.information[type] = file.id
            }
        },
        validate() {
            (async () => {
                const list = [
                    {
                        error: 'Personal Information',
                        value: await this.$refs.basicPersonalForm.$refs.form.validate()
                    },
                    {
                        error: 'Artist Information',
                        value: await this.$refs.artistWorkForm.$refs.form.validate()
                    },
                    {
                        error: 'Location Information',
                        value: await this.$refs.locationForm.$refs.form.validate()
                    },
                    {
                        error: 'Performance Details',
                        value: await this.$refs.performanceForm.$refs.form.validate()
                    },
                ];
                const errors = [];
                const valid = list.every(form => !!form.value);

                list.forEach(form => {
                    if (!form.value) errors.push(form.error)
                })

                if (valid) {
                    await this.updateArtistInfo()
                } else {
                    this.$showValidationErrorMessageAll(errors);
                }
            })();
        },
    },


}

</script>


<style>

</style>
